const PARAGRAPH_BASIC_BLOCK_TABS = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    type
    uuid
    ... on TabsBlock {
      id
      header
      blockTabs {
        body
        icon
      }
      iconBlock
      title
      type
      uuid
    }
  }
`;

export default PARAGRAPH_BASIC_BLOCK_TABS;
